<script lang="ts" setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { RouterLinkProps } from 'vue-router'

export interface Props extends RouterLinkProps {
    translation: string
    activated?: boolean
    requiresModuleLicense?: boolean
    isCollapsed?: boolean
}

const props = withDefaults(defineProps<Props>(), { activated: true, isCollapsed: false })
const { t } = useI18n()

const tooltipContent = computed(() => {
    if (props.isCollapsed) return t(props.translation)
    if (!props.activated && props.requiresModuleLicense) return t('noAccessForReadonly')
    return ''
})

const tooltipDisabled = computed(() => {
    if (props.isCollapsed) return false
    return props.activated || (!props.activated && !props.requiresModuleLicense)
})
</script>

<template>
    <RouterLink
        v-tooltip="{
            content: tooltipContent,
            disabled: tooltipDisabled,
            placement: 'right',
        }"
        :to="props.to"
        :active-class="props.activated ? 'bg-yellow-500 !text-dark-500' : ''"
        class="group flex items-center rounded-lg px-3 py-2 text-sm text-primary-200 transition-colors hover:bg-dark-800 hover:text-dark-700 dark:hover:text-dark-700"
        :class="{
            'opacity-50 cursor-not-allowed': !props.activated,
            'hover:bg-yellow-600 hover:text-dark-700': props.activated,
            'justify-center': props.isCollapsed,
        }"
    >
        <span :class="{ 'mr-3': !props.isCollapsed }" class="flex-shrink-0">
            <slot />
        </span>
        <span v-if="!props.isCollapsed" class="truncate">
            {{ t(props.translation) }}
        </span>
    </RouterLink>
</template>
